import React, {Component} from "react"
import PropTypes from "prop-types"
import {connect} from "react-redux"
import {login, setCurrentRegion} from "~/actions/authActions"
import {addFlashMessage} from "~/actions/flashMessages"

import {Form, FormSection, Field, SelectField} from "~/components/"

import {regions} from "../../utils"

import {withTranslation} from "react-i18next"

class LoginForm extends Component {
  constructor(props) {
    super(props)

    this.state = {
      email: "",
      password: "",
      errors: {},
      isLoading: false
    }
  }

  componentDidMount() {
    setCurrentRegion(regions.basel.id)
  }

  submit(params) {
    this.setState({errors: {}})
    return new Promise((resolve, reject) => {
      this.props
        .login(params)
        .then(() => {
          resolve()
        })
        .catch(err => {
          if (err.response) {
            this.setState({
              errors: {global: err.response.data.errors[0]}
            })
          } else {
            this.setState({
              errors: {
                global: this.props.t("errorMessage")
              }
            })
          }
          reject(err)
        })
    })
  }

  render() {
    const {email, password, errors} = this.state
    return (
      <div>
        <Form
          onSubmit={this.submit.bind(this)}
          submitLabel={this.props.t("login.submit")}
          getDefaultValue={(name, x) => ""}
          globalError={errors ? errors.global : null}
        >
          <FormSection>
            <Field
              label={this.props.t("login.email")}
              type="email"
              name="email"
              value={email}
              error={errors.email}
            />
            <Field
              label={this.props.t("login.password")}
              type="password"
              name="password"
              value={password}
              error={errors.password}
            />
            <SelectField
              label={this.props.t("login.region")}
              name="region"
              options={Object.values(regions)}
              onChange={option => setCurrentRegion(option)}
            />
          </FormSection>
          {/* <NavLink className="link" exact to="/forgot_password">
            Passwort vergessen?
          </NavLink> */}
        </Form>
      </div>
    )
  }
}

LoginForm.propTypes = {
  login: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired
}

export default withTranslation()(
  connect(null, {login, addFlashMessage})(LoginForm)
)



// WEBPACK FOOTER //
// ./src/components/forms/LoginForm.js